import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.AVOD_DP_season_selector]: 'Season {seasonNumber}',
  [StringId.DV_DP_Watchlist_toggle_label]: 'Watchlist',
  [StringId.DV_DP_WL_removeMovie]: 'Remove from {conditionalLineBreak}Watchlist',
  [StringId.DV_DP_WL_removeTv]: 'Remove Season from {conditionalLineBreak}Watchlist',
  [StringId.DV_DP_WL_addMovie]: 'Add to {conditionalLineBreak}Watchlist',
  [StringId.DV_DP_WL_addTv]: 'Add Season to {conditionalLineBreak}Watchlist',
  [StringId.DV_DP_WL_addTvProcessing]: 'Adding to {conditionalLineBreak}Watchlist',
  [StringId.DV_DP_WL_removeTvProcessing]: 'Removing from {conditionalLineBreak}Watchlist',
  [StringId.AVOD_WL_error_msg]: 'An error has occurred. Please try again shortly.',
  [StringId.DV_DP_WL_watchlist]: 'Watchlist'
}



